import React from 'react';
import '../less/energy-list.less';
import previewList01 from '../enums/preview_list_01.json';
import previewList02 from '../enums/preview_list_02.json';
import ProductList from '../../../../../auxiliary-components/shared/ProductList';
import { applyDarex, applyOnlySolar, businessAllCreditProductAwardLink, cpgEnergyLink, applyEnergySpecialOfferDefault } from '../../../../../services/urls/urls';
import award_img from '../img/award_img.svg'
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import BusinessOrder from '../../../../BusinessOrder';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import DOMPurify from 'utils/sanitize';
import specialOffersDataConfig from '../enums/special_offers_data.json';
import special_offers_img_1 from '../img/special_offers_img_1.svg';
import special_offers_img_2 from '../img/special_offers_img_2.svg';
import special_offers_img_3 from '../img/special_offers_img_3.svg';
import special_offers_img_4 from '../img/special_offers_img_4.svg';
import special_offers_img_5 from '../img/special_offers_img_5.svg';
import { Preloader } from 'MWComponents';
import PbpEntityOrder from './../../PbpEntityOrder';
import cpg_energy_img_01 from '../img/cpg_energy_img_01.svg';
import cpg_energy_img_02 from '../img/cpg_energy_img_02.svg';

const imagesMap = {
  special_offers_img_1,
  special_offers_img_2,
  special_offers_img_3,
  special_offers_img_4,
  special_offers_img_5
};

const handlersMap = {
  darexReadConditions: '/static/tariffs_darex_express-energy.pdf',
  darexApply: applyDarex,
  onlySolarReadConditions: '/static/tariffs_onlysolar_express-energy.pdf',
  onlySolarApply: applyOnlySolar,
  cyberVoltReadConditions: '/static/tariffs_cybervolt.pdf',
  energyLvivReadConditions: '/static/tariffs_energylviv.pdf',
  luxSolarReadConditions: '/static/tariffs_luxsolar.pdf',
  applyEnergySpecialOfferDefault
};

export default function template() {
  const page = 'energy-all';

  const generalInfoMemorandumLink = '/static/business/memorandum.pdf';

  const specialOffersData = specialOffersDataConfig.map(item => ({
    ...item,
    img: imagesMap[item.img],
    readBtn: handlersMap[item.readBtn],
    applyBtn: handlersMap[item.applyBtn]
  }));

  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');

  return (
    <div className="module-energy-all">
      <div>
        <div className="general-info">
          <div className="container">
            <h1 className="general-info__title">{this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_TITLE')}</h1>
            <div className="general-info__subtitle">{this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_SUBTITLE')}</div>
            <div className="general-info__text">
              <p>
                {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_TEXT_01_01')} 
                <a {...getSafeLinkProps(generalInfoMemorandumLink)}>
                  {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_LINK_01')}
                </a>
                {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_TEXT_01_02')} 
              </p>
              <p>
                {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_TEXT_02_01')} 
                <a {...getSafeLinkProps(generalInfoMemorandumLink)}>
                  {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_LINK_02')}
                </a>
                {this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_TEXT_02_02')} 
              </p>
            </div>
            <a className="general-info__award award" {...getSafeLinkProps(businessAllCreditProductAwardLink)}>
              <img src={award_img} alt={this.l10n('ENERGY_ALL_NEW_AWARD_TEXT')} className="award__image"/>
              <div className="award__content">
                <div className="award__title">{this.l10n('ENERGY_ALL_NEW_AWARD_TITLE')}</div>
                <div className="award__text">{this.l10n('ENERGY_ALL_NEW_AWARD_TEXT')}</div>
              </div>
            </a>
            <button className="general-info__btn" onClick={() => this.toggleModal()}>{this.l10n('ENERGY_ALL_NEW_GENERAL_INFO_BTN')}</button>
          </div>
        </div>
        <ProductList
          items={previewList01}
          page={page}
        />
        <div className="middle-text">
          <div className="container">{this.l10n('ENERGY_ALL_NEW_MIDDLE_TEXT')}</div>
        </div>
        <ProductList
          items={previewList02}
          page={page}
        />
      </div>
      <div className="special-offers">
        <div className="container">
          <div className="special-offers__body">
            {specialOffersData.map((item) => (
              <div className={`special-offers__item item-special-offers item-special-offers_${item.id}`} key={item.id}>
                <img className="item-special-offers__image" src={item.img} alt={`${item.id} image`} />
                <div className="item-special-offers__left">
                  <div className="item-special-offers__title">{this.l10n('ENERGY_ALL_NEW_SPECIAL_OFFERS_TITLE')}</div>
                  <div className="item-special-offers__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                  <div className="item-special-offers__btns">
                    <a className="item-special-offers__btn" {...getSafeLinkProps(item.readBtn)}>{this.l10n('ENERGY_ALL_NEW_SPECIAL_OFFERS_READ_BTN')}</a>
                    <a className="item-special-offers__btn item-special-offers__btn_apply" {...getSafeLinkProps(item.applyBtn)}>{this.l10n('ENERGY_ALL_NEW_SPECIAL_OFFERS_APPLY_BTN')}</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {this.state.loader ? (canUseDOM ? <Preloader /> : null) : 
        partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
          <div className="partners">
            <div className="container">
              <h2 className="partners__title">{this.l10n('ENERGY_ALL_NEW_PARTNERS_TITLE')}</h2>
              <div className="partners__row">
                {filterByEnvironment(partnersWidget.data).sort((a, b) => (a.order || 0) - (b.order || 0)).map((item, index) => (
                  <a className="partners__item item-partners" {...getSafeLinkProps(item.file_path)} key={item.id} >
                    <img
                      className="item-partners__image"
                      src={item.img_desktop}
                      alt={DOMPurify.sanitize(item.title, {
                        ALLOWED_TAGS: [],
                        ALLOWED_ATTR: []
                      })}
                    />
                    <div className="item-partners__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title)}}></div>
                  </a>
                ))}
              </div>
              <div className="partners__btn">
                <button onClick={this.toggleModal2}>{this.l10n('ENERGY_ALL_NEW_PARTNERS_BTN')}</button>
              </div>
            </div>
          </div>
        ) : null
      }
      <div className="cpg-energy">
        <div className="container">
          <div className="cpg-energy__body">
            <div className="cpg-energy__images">
              <img src={cpg_energy_img_01} alt="cpg energy image 1" />
              <img src={cpg_energy_img_02} alt="cpg energy image 2" />
            </div>
            <div className="cpg-energy__left">
              <h2 className="cpg-energy__title">{this.l10n('ENERGY_ALL_NEW_CPG_ENERGY_TITLE')}</h2>
              <a className="cpg-energy__btn" {...getSafeLinkProps(cpgEnergyLink, {target: '_blank'})}>
                {this.l10n('ENERGY_ALL_NEW_CPG_ENERGY_BTN')}
              </a>
            </div>
          </div>
        </div>
      </div>
      {this.state.showModal && <BusinessOrder attribute="energy_credit" closeModal={() => this.toggleModal()} />}
      {this.state.showModal2 && (
          <PbpEntityOrder attribute={'become a partner'} utmParams={this.state.utmParams} closeModal={this.toggleModal2} />
      )}
    </div>
  );
}
